"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _StyleProtectedMenuButton = _interopRequireDefault(require("../style-protected/StyleProtectedMenuButton"));

var _StyleProtectedUIMultiLevelDropdown = _interopRequireDefault(require("../style-protected/StyleProtectedUIMultiLevelDropdown"));

var _withDisabledContext = _interopRequireDefault(require("../hoc/withDisabledContext"));

var ToolbarMenu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(ToolbarMenu, _Component);

  function ToolbarMenu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ToolbarMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ToolbarMenu)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getOptionForMenuItem = function (menuItem) {
      var child = menuItem.child;

      if (!child) {
        return _this.renderMenuItem(menuItem);
      }

      if (typeof child === 'function') {
        child = child();
      }

      return {
        label: menuItem.text,
        options: [child],
        iconName: menuItem.icon,
        dropdownClassName: 'mce-sub-menu'
      };
    };

    return _this;
  }

  (0, _createClass2.default)(ToolbarMenu, [{
    key: "renderMenuItem",
    value: function renderMenuItem(_ref) {
      var name = _ref.name,
          onClick = _ref.onClick,
          text = _ref.text,
          render = _ref.render,
          icon = _ref.icon;

      if (typeof render === 'function') {
        return render({
          key: name
        });
      }

      return _react.default.createElement(_StyleProtectedMenuButton.default, {
        key: name,
        "data-test-id": name,
        onClick: onClick
      }, icon && _react.default.createElement(_UIIcon.default, {
        name: icon
      }), text);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          menuItems = _this$props.menuItems,
          className = _this$props.className,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["menuItems", "className"]);
      return _react.default.createElement(_StyleProtectedUIMultiLevelDropdown.default, (0, _extends2.default)({
        buttonClassName: className,
        buttonUse: "transparent",
        animateOnToggle: false,
        options: menuItems.map(this.getOptionForMenuItem)
      }, rest));
    }
  }]);
  return ToolbarMenu;
}(_react.Component);

ToolbarMenu.propTypes = {
  menuItems: _react.PropTypes.array.isRequired,
  className: _react.PropTypes.string
};

var _default = (0, _withDisabledContext.default)(ToolbarMenu);

exports.default = _default;
module.exports = exports.default;